import { CustomerPayload } from './update-subscription.model';

export class ContactForm {
  name!: string;
  phoneNumber?: string;
  email!: number;
  message?: string;
  customer!: CustomerPayload;
}
